import { render, staticRenderFns } from "./DetailedTransferOut.vue?vue&type=template&id=06b7eae1&scoped=true"
import script from "./DetailedTransferOut.vue?vue&type=script&lang=js"
export * from "./DetailedTransferOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b7eae1",
  null
  
)

export default component.exports